import { useComponentModal } from '@msdk/forms'
import { DataRetentionDialog } from 'components/DataRetentionDialog/DataRetentionDialog'
import { HomeSelector } from 'components/HomeSelector/HomeSelector'
import { useDataRetentionConfirmed } from 'hooks/useDataRetentionConfirmed'
import { useEffect } from 'react'

export function Home() {
  const dialogModal = useComponentModal()
  // const openNGID = window.location.search.includes('openNGID=true')
  const { result: isDataRetentionConfirmed, onClose: onCloseDPR } = useDataRetentionConfirmed()
  // const {
  //   result: isUserDialysisMachineSignedIn,
  //   onClose: onCloseNGID,
  //   startIndex,
  // } = useUserDialysisMachineSignedIn(openNGID)

  useEffect(() => {
    if (isDataRetentionConfirmed != undefined) {
      // if (isDataRetentionConfirmed != undefined && isUserDialysisMachineSignedIn != undefined) {
      if (!isDataRetentionConfirmed) {
        dialogModal.createModal(<DataRetentionDialog />, onCloseDPR).open()
      }
      // if (!isUserDialysisMachineSignedIn && isDataRetentionConfirmed) {
      //   dialogModal
      //     .createModal(<UserAuthenticationNGID startIndex={startIndex} />, onCloseNGID, {
      //       preventClickOutside: false,
      //       preventEscapeFromClosing: false,
      //     })
      //     .open()
      // }
    }
    // }, [isUserDialysisMachineSignedIn, isDataRetentionConfirmed])
  }, [isDataRetentionConfirmed])

  // return <>{isDataRetentionConfirmed && isUserDialysisMachineSignedIn && <HomeSelector />}</>
  return <>{isDataRetentionConfirmed && <HomeSelector />}</>
}
